import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import Maps from './Maps';
import PlayersTab from './tournament/PlayersTab';
import RulesTab from './tournament/RulesTab';
import { getBracketEmbeds } from './tournament/tournamentHelpers';

const BracketExternalTournamentView = ({ tournament, players, tournamentId }) => {
  const bracketEmbeds = getBracketEmbeds(tournament);
  return (
    <Tabs defaultValue="bracket" className="w-full">
      <TabsList className="w-full justify-start overflow-x-auto">
        <TabsTrigger value="bracket">Bracket</TabsTrigger>
        {!tournament.hideMaps && <TabsTrigger value="maps">Maps</TabsTrigger>}
        <TabsTrigger value="rules">Rules</TabsTrigger>
        <TabsTrigger value="players">Players</TabsTrigger>
      </TabsList>

      <TabsContent value="bracket">
        {bracketEmbeds.length > 0 ? (
          <div className="grid gap-6">
            {bracketEmbeds.map((embed, index) => (
              <article
                key={`${embed.url}-${index}`}
                className="overflow-hidden rounded-md border border-border/60 bg-background/40"
              >
                <div className="flex flex-wrap items-center justify-between gap-3 border-b border-border/60 px-4 py-3">
                  <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                    {embed.label || `Bracket ${index + 1}`}
                    {bracketEmbeds.length > 1 && (
                      <span className="ml-2 text-foreground/40">
                        · {index + 1} / {bracketEmbeds.length}
                      </span>
                    )}
                  </div>
                  <a
                    href={embed.url}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="font-mono text-[10px] uppercase tracking-[0.2em] text-heat underline-offset-2 hover:underline"
                  >
                    Open bracket
                  </a>
                </div>
                <div className="h-[480px] w-full bg-white sm:h-[640px] lg:h-[800px]">
                  <iframe
                    src={embed.url}
                    title={embed.label || `Tournament bracket ${index + 1}`}
                    className="h-full w-full border-0"
                    sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                  />
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="border border-dashed border-border/60 px-6 py-12 text-center text-sm text-muted-foreground">
            No bracket URL configured for this tournament.
          </div>
        )}
      </TabsContent>

      {!tournament.hideMaps && (
        <TabsContent value="maps">
          <Maps tournamentId={tournamentId} />
        </TabsContent>
      )}

      <TabsContent value="rules">
        <RulesTab html={tournament.rules} />
      </TabsContent>

      <TabsContent value="players">
        <PlayersTab players={players} />
      </TabsContent>
    </Tabs>
  );
};

export default BracketExternalTournamentView;
